import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, CardFooter, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { toast } from "react-toastify";

import { confirm } from "components/Confirmation";

import IconButton from "components/IconButton";
import CustomPagination from "components/CustomPagination";
import modeloComponenteService from "services/ModeloComponenteService";
import comboService from "services/ComboService";

export default function ModelosComponente() {
  const [pagina, setPagina] = useState(1)
  const [paginas, setPaginas] = useState(0)
  const [termo, setTermo] = useState(null)
  const [idTipoComponente, setIdTipoComponente] = useState(null)
  const [items, setItems] = useState([])
  const [tiposComponente, setTiposComponente] = useState([])
  const navigate = useNavigate()

  const carregar = async () => {
    const res = await modeloComponenteService.get(termo, idTipoComponente, pagina)
    if (res.success) {
      setItems(res.data.items)
      setPaginas(res.data.paginas)
    }
  }

  useEffect(() => {
    carregar()
  }, [pagina])

  useEffect(() => {
    comboService.tipoComponente().then(res => {
      if (res.success) {
        setTiposComponente(res.data)
      }
    })
  }, [])

  const handleDelete = (item) => {
    confirm({
      header: "Exclusão",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          const res = await modeloComponenteService.delete(item.id)
          if (res.success) {
            carregar()
            toast("Modelo de componente excluído")
          } else {
            toast("Erro ao excluir o modelo de componente")
          }
        } catch (ex) {
          if (!!ex.response.data?.message)
            toast(ex.response.data.message)
          else
            toast("Erro ao excluir o modelo de componente")
        }
      }
    })
  }

  const handleSubmit = e => {
    e.preventDefault()
    setPagina(1)
    carregar()
  }

  return (
    <>
      <Container fluid>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <h1 className="my-4">Modelos de Componente</h1>
          <Link className="btn btn-primary btn-icon" to="/admin/modelos-componente/0">Incluir</Link>
        </div>

        <Card className="shadow mb-4">
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <FormGroup>
                    <Label>Descrição</Label>
                    <Input type="text" placeholder="Descrição" value={termo || ''} onChange={e => setTermo(e.target.value)} />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Tipo de Componente</Label>
                    <select className="form-control" value={idTipoComponente || ''} onChange={e => setIdTipoComponente(e.target.value)}>
                      <option value="">Todos</option>
                      {tiposComponente.map(el => (
                        <option key={el.id} value={el.id}>{el.descricao}</option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
                <Col className="d-flex align-items-end justify-content-end">
                  <FormGroup>
                    <Button type="submit" color="primary">Buscar</Button>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card className="shadow">
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">Descrição</th>
                <th scope="col">Tipo</th>
                <th scope="col" style={{ width: 120 }}></th>
              </tr>
            </thead>
            <tbody>
              {items.length == 0 && (
                <tr>
                  <td colSpan={3} className="text-center">Nenhum registro</td>
                </tr>
              )}
              {items.map(el => (
                <tr key={el.id}>
                  <td>{el.descricao}</td>
                  <td>{el.tipoComponente.descricao}</td>
                  <td className="d-flex flex-row gap-5px">
                    <IconButton alt="Editar" iconClass="bi-pencil-square" onClick={() => navigate("/admin/modelos-componente/" + el.id)} />
                    <IconButton alt="Excluir" iconClass="bi-trash" onClick={() => handleDelete(el)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <CardFooter className="py-4">
            <CustomPagination pagina={pagina} paginas={paginas} onChange={setPagina} />
          </CardFooter>
        </Card>
      </Container>
    </>
  )
}
